import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FramerRequestComponent } from '../../to-back/framer-request/framer-request.component';

@Component({
  selector: 'app-become-partner-teacher',
  templateUrl: './become-partner-teacher.component.html',
  styleUrls: ['./become-partner-teacher.component.scss'],
  providers: [DialogService, MessageService]
})
export class BecomePartnerTeacherComponent implements OnInit, OnDestroy {
  ref: DynamicDialogRef;

  constructor(
    private dialogService: DialogService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
  }

  show(): void {
    // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Message Content' });
    // return;
    this.ref = this.dialogService.open(FramerRequestComponent, {
        width: '50%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000
    });

    this.ref.onClose.subscribe((product: any) => {
        if (product) {
            this.messageService.add({ severity: 'info', summary: 'Product Selected', detail: product.name });
        }
    });

    this.ref.onMaximize.subscribe((value) => {
        this.messageService.add({ severity: 'info', summary: 'Maximized', detail: `maximized: ${value.maximized}` });
    });
  }

  ngOnDestroy() {
    if (this.ref) {
        this.ref.close();
    }
  }

}
